import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "centsToDollars",
	standalone: true
})
export class CentsToDollarsPipe implements PipeTransform {
	transform(cents: number): string {
		if (cents > 0) {
			if (cents % 100 === 0) {
				return "$" + (cents / 100).toFixed(0);
			}
			else {
				return "$" + (cents / 100).toFixed(2);
			}
		}
		else if (cents === 0) {
			return "$0";
		}
		else {
			if (cents % 100 === 0) {
				return "-$" + (Math.abs(cents) / 100).toFixed(0);
			}
			else {
				return "-$" + (Math.abs(cents) / 100).toFixed(2);
			}
		}
	}
}
